$(document).ready(function () {
  if ($(document).width() < 982) {
    let banner = $(".popup-wrapper").height();

    $(".navbar-collapse").on("show.bs.collapse", function () {
      setPopupHeightVar(banner);
      $("body").addClass("menu-main-is-open");
    });

    $(".navbar-collapse").on("hide.bs.collapse", function () {
      $("body").css("--apriorit-popup-height", banner + "px");
      $("body").removeClass("menu-main-is-open");
      $("body").removeClass("search-results-shown");
    });

    $(".navbar-collapse").on("show.bs.dropdown", function(event){
      $(event.target).parent().siblings().addClass('d-none');
    });

    $(".navbar-collapse").on("hide.bs.dropdown", function(event){
      $(event.target).parent().siblings().removeClass('d-none');
    });
  } else {
    $("#menu-main .dropdown").on("show.bs.dropdown", function () {
      $("body").addClass("menu-main-is-open");
    });

    $("#menu-main .dropdown").on("hidden.bs.dropdown", function () {
      if ($("#menu-main").find(".dropdown-menu.depth-0.show").length == 0) {
        $("body").removeClass("menu-main-is-open");
      }
    });

    $(".navbar-nav .menu-item span, .navbar-nav .menu-item .dropdown-menu, .navbar-nav .menu-item .top-level-menu-list").on({
      mouseenter: function () {
        $("#main, .contact-form, #footer").addClass('blurred');
      },
      mouseleave: function () {
        $("#main, .contact-form, #footer").removeClass('blurred');
      }
    });
  }
  
  $('.top-level-menu-list').on('click', function (e) {
    let $this = $(this);
    
    if ($(document).width() > 1199 && $(e.target).is('a')) {
      // Only follow the link if dropdown is not already open
      window.location.href = $this.attr('href');
    }
  });
});

function setPopupHeightVar(bannerHeight) {
  if (jQuery(document).scrollTop() >= bannerHeight) {
    jQuery("body").css("--apriorit-popup-height", "0px");
  } else {
    jQuery("body").css(
      "--apriorit-popup-height",
      bannerHeight - jQuery(document).scrollTop() + "px"
    );
  }
}

